module.exports = __webpack_public_path__ + "img/client-contract.adaa8914.svg";